import React from 'react'
import './SearchPage.css';
import TuneIcon from '@material-ui/icons/Tune';
import ChannelRow from './ChannelRow';
import VideoRow from './VideoRow';

function SearchPage() {
    return (
        <div className="searchPage">
            <div className="searchPage__filter">
                <TuneIcon/>
                <h2>FILTER</h2>
            </div>
            <hr/>
            <ChannelRow
                image="https://yt3.ggpht.com/ytc/AAUvwni28ACKilGKyGl6J-Kx2nMQFFqwZCi4kZXokAwV_Q=s88-c-k-c0x00ffffff-no-rj"
                channel="LaLiga"
                verified
                subs="281K"
                noOfVideos="421"
                description="No te pierdas ga SmartBank. // Don’t miss any detail of what happens this season in LaLiga SmartBank (Second Spanish Division)"
            />
            <hr/>
            <VideoRow
                views="1.4M"
                subs="659K"
                description="Subscribe to LaLiga SmartBank (bit.ly/1OvSXbi) to watch LIVE all LaLiga SmartBank games in HD on YouTube. The competition can be w: Africa: Angola,..."
                timestamp="Live"
                channel="LaLiga"
                title="Real Oviedo - Albacete BP MD23 S1600"
                image="https://i.ytimg.com/vi/_Pd985swYNQ/hqdefault_live.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLADTDedgaJHTIUOGC30AKO2kWal5w"
            />

            <VideoRow
                views="1.4M"
                subs="659K"
                description="Subscribe to LaLiga SmartBank (bit.ly/1OvSXbi) to watch LIVE all LaLiga SmartBank games in HD on YouTube. The competition can be w: Africa: Angola,..."
                timestamp="Live"
                channel="LaLiga"
                title="Real Oviedo - Albacete BP MD23 S1600"
                image="https://i.ytimg.com/vi/_Pd985swYNQ/hqdefault_live.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLADTDedgaJHTIUOGC30AKO2kWal5w"
            />


            <VideoRow
                views="1.4M"
                subs="659K"
                description="Subscribe to LaLiga SmartBank (bit.ly/1OvSXbi) to watch LIVE all LaLiga SmartBank games in HD on YouTube. The competition can be w: Africa: Angola,..."
                timestamp="Live"
                channel="LaLiga"
                title="Real Oviedo - Albacete BP MD23 S1600"
                image="https://i.ytimg.com/vi/_Pd985swYNQ/hqdefault_live.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLADTDedgaJHTIUOGC30AKO2kWal5w"
            />

            <VideoRow
                views="1.4M"
                subs="659K"
                description="Subscribe to LaLiga SmartBank (bit.ly/1OvSXbi) to watch LIVE all LaLiga SmartBank games in HD on YouTube. The competition can be w: Africa: Angola,..."
                timestamp="Live"
                channel="LaLiga"
                title="Real Oviedo - Albacete BP MD23 S1600"
                image="https://i.ytimg.com/vi/_Pd985swYNQ/hqdefault_live.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLADTDedgaJHTIUOGC30AKO2kWal5w"
            />

            <VideoRow
                views="1.4M"
                subs="659K"
                description="Subscribe to LaLiga SmartBank (bit.ly/1OvSXbi) to watch LIVE all LaLiga SmartBank games in HD on YouTube. The competition can be w: Africa: Angola,..."
                timestamp="Live"
                channel="LaLiga"
                title="Real Oviedo - Albacete BP MD23 S1600"
                image="https://i.ytimg.com/vi/_Pd985swYNQ/hqdefault_live.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLADTDedgaJHTIUOGC30AKO2kWal5w"
            />

            <VideoRow
                views="1.4M"
                subs="659K"
                description="Subscribe to LaLiga SmartBank (bit.ly/1OvSXbi) to watch LIVE all LaLiga SmartBank games in HD on YouTube. The competition can be w: Africa: Angola,..."
                timestamp="Live"
                channel="LaLiga"
                title="Real Oviedo - Albacete BP MD23 S1600"
                image="https://i.ytimg.com/vi/_Pd985swYNQ/hqdefault_live.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLADTDedgaJHTIUOGC30AKO2kWal5w"
            />

            <VideoRow
                views="1.4M"
                subs="659K"
                description="Subscribe to LaLiga SmartBank (bit.ly/1OvSXbi) to watch LIVE all LaLiga SmartBank games in HD on YouTube. The competition can be w: Africa: Angola,..."
                timestamp="Live"
                channel="LaLiga"
                title="Real Oviedo - Albacete BP MD23 S1600"
                image="https://i.ytimg.com/vi/_Pd985swYNQ/hqdefault_live.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLADTDedgaJHTIUOGC30AKO2kWal5w"
            />
        </div>
    )
}

export default SearchPage
